import React, { createContext, useContext, useState, useEffect } from 'react';
import dataLoader from '../services/dataLoader';

const DataContext = createContext();

export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
};

export const DataProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState(null);
  const [loadingStartTime, setLoadingStartTime] = useState(null);

  const loadData = async () => {
    setIsLoading(true);
    setProgress(0);
    setError(null);
    setLoadingStartTime(Date.now());

    try {
      const bankData = await dataLoader.loadBankData((progress) => {
        setProgress(progress);
      });

      setData(bankData);
      setIsLoading(false);
      
      // Calculate loading time
      const loadingTime = Date.now() - loadingStartTime;
      console.log(`✅ Bank data loaded successfully in ${loadingTime}ms`);
      console.log(`📊 Total records: ${bankData.data?.length || 0}`);
      console.log(`💾 Cache status:`, dataLoader.getCacheStatus());
      
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
      console.error('❌ Failed to load bank data:', err);
    }
  };

  const retry = () => {
    setError(null);
    loadData();
  };

  const clearCache = () => {
    dataLoader.clearCache();
    setData(null);
    setProgress(0);
    setError(null);
    loadData();
  };

  // Load data on mount
  useEffect(() => {
    loadData();
  }, []);

  const value = {
    data,
    isLoading,
    progress,
    error,
    retry,
    clearCache,
    loadData,
    cacheStatus: dataLoader.getCacheStatus()
  };

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
}; 